import styled, { css } from "styled-components"
import { colors, device } from "../styles/stylesConfig"
import { useTranslation } from "react-i18next"

const Container = styled.section`
    width: 100%;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: ${colors.dark};
`

const Target = styled.div`
    height: 0px;
    width: 0px;
    position: absolute;
    top: -15vh;
    left: 0px;

    @media ${device.md} {
        top: -15vh;
    }

    @media ${device.sm} {
        top: -10vh;
    }
`

const ContentContainer = styled.div<{ img: string }>`
    width: 100%;
    min-height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    @media ${device.md} {
        width: 100%;
        min-height: unset;
        padding: 5rem 0rem;

        ${({ img }) => img && css`
        background: url(${img}) bottom no-repeat;
        background-size: cover;
    `}

    &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.7); 
        z-index: 0;
    }
}
`

const Info = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    z-index: 2;
    position: relative;
    overflow: hidden;

    @media ${device.md} {
        width: 100%;
    }
    
`

const Image = styled.div<{ img: string }>`
    width: 60%;
    min-height: 600px;
    z-index: 0;
    position: relative;

    ${({ img }) => img && css`
        background: url(${img}) bottom no-repeat;
        background-size: cover;
    `}

    @media ${device.md} {
        min-height: unset;
        visibility: hidden;
        position: absolute;
    }
    
`

const Title = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;

    & > h1 {
        width: 100%;
        text-align: start;
        font-weight: bold;
        font-size: 38px;
        color: ${colors.dark};
        letter-spacing: 2px;
        line-height: 60px;
        margin-bottom: 20px;
        text-transform: uppercase;
        transition: all 0.3s ease-in-out;
        position: relative;
        
        
        @media ${device.lg} {
            font-size: 32px;
        }
        
        @media ${device.md} {
            color: white;
            font-size: 28px;
            text-align: center;
        }   

        @media ${device.sm} {
            font-size: 20px;
            line-height: 30px;
        }
    }
    
`

const History = styled.div`
    width: 40%;
    height: 600px;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    z-index: 1;
    padding-left: 10vw;
    background-color: white;
    position: relative;
    /*  */
    
    @media ${device.lg} {
    }
    
    @media ${device.md} {
        width: 80%;
        padding-left: unset;
        align-items: center;
        height: fit-content;
        background-color: transparent;
    }


    & > p {
        font-size: 18px;
        color: ${colors.dark};
        text-align: justify;
        font-weight: 400;
        z-index: 2;

        @media ${device.lg} {
            line-height: 25px;
            font-size: 16px;
        }
        
        @media ${device.md} {
            text-align: center;
            font-size: 14px;
            color: white;
        }

        @media ${device.sm} {
            font-size: 12px;
        }
    }

    & > p:last-of-type {
        margin-bottom: 0;
    }
    
`

const Border = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: -150px;
    z-index: 1;
    height: 750px;
    width: 300px;
    background-color: white;
    transform: rotate(17deg);
    border-right: 30px solid #fe0413;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        background-color: #024ab9;
    }

    @media ${device.md} {
        display: none;
    }
`

export const AboutVehicles = () => {

    const { t } = useTranslation();

    return (

        <Container>

            <Target id="about" />

            <ContentContainer
                img={require('../images/vehiculos.webp')}
            >

                <Info>

                    <History>

                        <Title className='utils__fade-in-fast-top'>

                            <h1>{t('about.vehicles.title')}</h1>

                        </Title>

                        <p className='utils__fade-in-fast-top'>{t('about.vehicles.description')}</p>

                        <Border />

                    </History>

                    <Image
                        className='utils__fade-in-fast-top'
                        img={require('../images/vehiculos.webp')}
                    />

                </Info>

            </ContentContainer>

        </Container>

    )
}